var Store = /** @class */ (function () {
    function Store(storage, storeKey) {
        this.data = null;
        this.storage = storage;
        this.STORE_KEY = storeKey;
        this.load();
    }
    Store.prototype.load = function () {
        var storeJSON = this.storage.getItem(this.STORE_KEY);
        if (storeJSON) {
            this.data = JSON.parse(storeJSON);
        }
        else {
            this.create();
        }
    };
    Store.prototype.getAll = function () {
        return this.data;
    };
    Store.prototype.setAll = function (data) {
        this.data = data;
        this.save();
    };
    Store.prototype.getItem = function (key) {
        if (!this.itemExists(key)) {
            return null;
        }
        return this.data[key];
    };
    Store.prototype.setItem = function (key, value) {
        this.data[key] = value;
        this.save();
    };
    Store.prototype.removeItem = function (key) {
        delete this.data[key];
        this.save();
    };
    Store.prototype.itemExists = function (key) {
        return this.data.hasOwnProperty(key);
    };
    Store.prototype.clear = function () {
        this.create();
    };
    Store.prototype.create = function () {
        this.data = {};
        this.save();
    };
    Store.prototype.save = function () {
        this.storage.setItem(this.STORE_KEY, JSON.stringify(this.data));
    };
    return Store;
}());
export default Store;
